export class AgrAction {

  public label: string;
  public value?: string;
  public icon?: string;
  item?: any;

}
